import { fetchAuth } from "./FetchAuth"

export const fetchBaseUrl = `${fetchAuth}/api/listing`

